// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"private_wrapper__nEfuT","loader":"private_loader__2f2nh"};